import { Box, Button, Container, Divider, Grid, Paper, SxProps, Theme, Typography } from "@mui/material";
import { icon } from "../../../pages/WorkSpaceItem/WorkSpaceItemListStyle/ColumnStandard";
import { KeyboardArrowLeftOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { MouseEventHandler } from "react";

interface IKeyDrivePageContainer {
    icon: React.ReactNode | string;
    title: React.ReactNode | string;
    subtitle?: React.ReactNode | string;
    children: React.ReactNode;
    actions?: React.ReactNode;
    sxActions?: SxProps<Theme> | undefined
    divider?: boolean;
    onClickBtnBack?: MouseEventHandler<HTMLButtonElement> | undefined
}

export function KeyDrivePageContainer(props: IKeyDrivePageContainer) {
    const { t } = useTranslation();
    return (
        <Container sx={{ padding: "30px", maxWidth: { xs: "100%", sm: "100%", md: "100%", lg: "100%", xl: "100%" } }}>
            <Grid item sx={{
                backgroundColor: "#FFFFFF !important",
                width: "100% !important",
                border: "1px solid #0000001A !important",
                borderRadius: "10px !important",
                display: "flex !important",
                flexDirection: "column !important",
                padding: "20px !important",
            }}>
                {props.onClickBtnBack && <Box mb={1}>
                    <Button
                        sx={{
                            color: "#22638D",
                            font: "normal normal normal 14px/21px Segoe UI",
                            textTransform: "none"
                        }}
                        startIcon={<KeyboardArrowLeftOutlined />}
                        onClick={props.onClickBtnBack}>
                        {t("AdminConsole.Back")}
                    </Button>
                </Box>}
                <Box display="flex"
                    justifyContent="space-between">
                    <Box>
                        <Box sx={{
                            display: "flex!important",
                            alignItems: "center !important",
                            gap: "12px !important"
                        }}>
                            <Box sx={{
                                backgroundColor: "#E8EFF3 !important",
                                width: "40px !important",
                                height: "40px !important",
                                display: "flex !important",
                                alignItems: "center !important",
                                justifyContent: "center !important",
                                borderRadius: "4px !important"
                            }}>
                                {props.icon}
                            </Box>
                            <Typography sx={{ font: "normal normal 600 20px/27px Segoe UI", color: "#2D2D2D" }}>
                                {props.title}
                            </Typography>
                        </Box>
                        {props.subtitle && <Typography sx={{
                            margin: "11px 0 0",
                            font: "normal normal normal 14px/21px Segoe UI"
                        }}>
                            {props.subtitle}
                        </Typography>}
                    </Box>
                    <Box sx={props.sxActions}>
                        {props.actions && props.actions}
                    </Box>
                </Box>

                {props.divider && <Divider sx={{ mt: 2, mb: 2 }} />}

                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "calc(100vh - 280px)"
                }}>{props.children}</Box>
            </Grid>
        </Container >
    )
}